import React, { useEffect } from "react";
import SubCategory from "./SubCategory";
import { Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useSubCategories } from "../api/get-subcategories";
import { useInView } from "react-intersection-observer";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { formatString } from "utils/encodeDecodeStr";
import { useGlobalContext } from "context/GlobalContext";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const SubCategories = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setFilterChangeCount, setDisplayCount ,  dynamicfilterCount , setFilterChangeDesignCount , filterChangeCount , filterChangeDesignCount , setSearchResultCount , setDynamicFilterCount,setSearchPlaceHolder} = useGlobalContext();

  const name = location.state?.name[0];
  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useSubCategories({
    categoryName: name,
    limit: 30,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    searchTerm: search,
  });

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 1.0,
  });

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  // useEffect(() => {
  //     setFilterChangeCount(data?.pages[0]?.totalUniqueSubCategoryCount);
  //     // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
  //     setDisplayCount(true);
  //     return () => {
  //       setFilterChangeCount(0);
  //       // setFilterChangeDesignCount(0);
  //       setDisplayCount(false);
  //     };
  //   }, [data]);

   useEffect(() => {
    setSearchPlaceHolder("Search By Category or Design Number")
      if(search === ""){
        setDynamicFilterCount(true);
      }
      if (dynamicfilterCount) {
        setFilterChangeCount(data?.pages[0]?.totalUniqueSubCategoryCount);
        // setFilterChangeDesignCount(data?.pages[0]?.totalDesginCount);
        setSearchResultCount(data?.pages[0]?.totalUniqueSubCategoryCount);
      } else {
        setSearchResultCount(data?.pages[0]?.totalUniqueSubCategoryCount);
        setFilterChangeCount(filterChangeCount);
        // setFilterChangeDesignCount(filterChangeDesignCount);
      }
      setDisplayCount(true);
      return () => {
        setSearchResultCount(0);
        setFilterChangeCount(0);
        // setFilterChangeDesignCount(0);
        setDisplayCount(false);
        setSearchPlaceHolder("")
      };
    }, [data]);

  // Extract category name from the pathname if location.state is null
  const categoryNameFromPath = location.pathname.split("/").pop();

  // Update location.state if it's null
  useEffect(() => {
    if (!location.state?.name) {
      navigate(location.pathname, { state: { name: [formatString(categoryNameFromPath)] }, replace: true });
    }
  }, []);

  if (isLoading) return <LoadingSmallCard count={20} />;
  if (isError) return <div>Error: {error.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.subCategories?.length && !page?.cardData?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <Grid
        container
        // spacing={2}
        // rowGap={{ lg: 1 }}
        // columnGap={{ lg: 1.2 }}
        //  rowSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
        //  columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}

        // justifyContent="flex-start"
        // alignItems="center"
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
      >
        {data?.pages?.map((page) =>
          page?.subCategories?.map((subcategory, _ind) => (
            <Grid item key={subcategory.subCategory}>
              <SubCategory subcategory={subcategory} />
            </Grid>
          ))
        )}
      </Grid>

      {isFetchingNextPage && <p style={{ color: "red" }}>Loading.......</p>}

      <div ref={ref} style={{ height: "20px", marginTop: "10px" }} />
    </>
  );
};

export default SubCategories;
